import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportDataComponent } from './report-data.component';



@NgModule({
  declarations: [ReportDataComponent],
  imports: [
    CommonModule
  ],exports: [ReportDataComponent]
})
export class ReportDataModule { }
